import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Request Dashboard Cards
@docs
*/
export const requestDashboardCards = () => {
	return httpClient({
		method: 'GET',
		url: 'home/dashboardCards',
		isCancellable: true,
		params: { isNewVersion: true }
	})
}

/** Request Home Patrimony
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_homepatrimony
*/
export const requestHomePatrimony = () => {
	return httpClient({
		method: 'GET',
		url: 'home/patrimony',
		isCancellable: true
	})
}

/** Create url for patrimony excel
@docs
*/
export const createPatrimonyExcelUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'home/patrimony/export'
	})
}
